import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [principal, setPrincipal] = useState(null); // null = checking, false = anonymous
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setPrincipal(data);
      } catch {
        setPrincipal(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password, remember_me = false) => {
    try {
      const { data } = await api.post("/auth/login", { email, password, remember_me });
      if (data.token) localStorage.setItem("iz_token", data.token);
      setPrincipal(data);
      return { ok: true, principal: data };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("iz_token");
    setPrincipal(false);
  };

  const isAdmin = principal && principal.subject_type === "admin";
  const roleName = principal?.role?.name;
  const roleType = principal?.role?.type;

  return (
    <AuthContext.Provider value={{ principal, admin: principal, loading, login, logout, isAdmin, roleName, roleType }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
